package com.vizio.redwolf.pay.api

import com.vizio.redwolf.pay.model.Asset
import com.vizio.redwolf.pay.model.CreateSupportCaseRequest
import com.vizio.redwolf.pay.model.CreateSupportCaseResponse
import com.vizio.redwolf.pay.model.CustomerSupportResult
import com.vizio.redwolf.pay.model.FirmwareVersionResponse
import com.vizio.redwolf.pay.model.SerialNumberRequest
import com.vizio.redwolf.pay.model.SerialNumberResponse
import com.vizio.redwolf.pay.model.SupportHoursResponse
import com.vizio.redwolf.utils.model.MobileHeaderInfo

interface CustomerSupportApi {

    suspend fun validateSerialNumber(serialNumberRequest: SerialNumberRequest): CustomerSupportResult<SerialNumberResponse>

    suspend fun getProductAssets(id: String): CustomerSupportResult<List<Asset>>

    suspend fun getSupportHours(): CustomerSupportResult<SupportHoursResponse>

    suspend fun getProductFirmwareVersion(serialNumber: String): CustomerSupportResult<FirmwareVersionResponse>

    suspend fun createSupportCase(createSupportCaseRequest: CreateSupportCaseRequest, mobileHeaderInfo: MobileHeaderInfo? = null): CustomerSupportResult<CreateSupportCaseResponse>

}